export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7908.675b9c16.jpg";